import { FC, useMemo } from "react";

import {
  NOTIFICATION_ACTION_TYPES,
  createNotificationAction,
} from "shared/ui/notifications/notification-generic/base-parts/actions";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

import { NotificationBase } from "@/modules/notifications/notification/base";
import {
  DialBlockStrikeAlertNotificationI,
  NotificationI,
} from "@/lib/types/notification";
import Router from "@/helpers/router";

type NotificationDialBlockStrikeAlertPropsI = NotificationI &
  PropsWithClassNameI;

/** The alert in one sentence (C12-D200). */
export const describeStrikeAlert = (
  alert: DialBlockStrikeAlertNotificationI | undefined
): string => {
  const who = alert?.caller_name?.trim() || "A caller";
  const where = alert?.workspace_name?.trim()
    ? ` on ${alert.workspace_name.trim()}`
    : "";

  return `${who} reached ${alert?.live_strikes ?? 3} strikes${where}. Strikes are a flag: review them in Rep Health.`;
};

/**
 * DialBlockStrikeAlert (C-14 W3 follow-up, C12-D200): a caller the
 * recipient manages (their LGA, or their Pod Lead) reached 3 live strikes.
 * Opens Rep Health on that workspace with the caller's sheet.
 */
export const NotificationDialBlockStrikeAlert: FC<
  NotificationDialBlockStrikeAlertPropsI
> = (props) => {
  const { id, is_seen, created_at, className, dial_block_strike_alert } = props;
  const text = useMemo(
    () => describeStrikeAlert(dial_block_strike_alert),
    [dial_block_strike_alert]
  );

  return (
    <NotificationBase
      id={id}
      isUnread={!is_seen}
      className={className}
      avatar={props}
      description={{ text: <>{text}</>, date: created_at }}
      actions={[
        createNotificationAction(
          NOTIFICATION_ACTION_TYPES.PRIMARY,
          "Open Rep Health",
          () => {
            window.location.href = Router.manageRepHealth(
              dial_block_strike_alert?.workspace_id,
              dial_block_strike_alert?.caller_user_id
            );
          }
        ),
      ]}
    />
  );
};
